'use client';

import { SessionData } from '@auth0/nextjs-auth0/types';
import CartButton from 'components/app/header/CartButton';
import HamburgerButton from 'components/app/header/HamburgerButton';
import SavedPlansButton from 'components/app/header/SavedPlansButton';
import Auth0Login from 'components/Auth0Login';
import Logo from 'components/Logo';
import AdminIcon from './icons/AdminIcon';
// import Translation from 'components/Translation';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ReactElement, useEffect } from 'react';
import { useMobileNav } from 'contexts/MobileNavContext';
import AvatarButton from './AvatarButton';
import MobileNav from './app/header/MobileNav';

export default function ExperienceNav({
  // TODO: Add DraftModeButton to MobileNav and pass in draftModeEnabled and previewEnabled as props, fix CORS issue
  // draftModeEnabled,
  // previewEnabled,
  session,
  isAdmin = false,
}: {
  draftModeEnabled: boolean;
  previewEnabled: boolean;
  session: null | SessionData;
  isAdmin?: boolean;
}): ReactElement {
  const pathname = usePathname();

  const { isMobileNavOpen, setIsMobileNavOpen } = useMobileNav();
  const toggleMenu = () => setIsMobileNavOpen(!isMobileNavOpen);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsMobileNavOpen(false);
      }
    };

    if (isMobileNavOpen) {
      document.addEventListener('keydown', handleEsc);
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isMobileNavOpen, setIsMobileNavOpen]);

  const isOnAdminPage = pathname.startsWith('/admin');
  const isOnBrowseResultsPage = pathname.startsWith('/browse/plans');

  return (
    <header
      className={`experience-nav${
        isOnBrowseResultsPage ? ' experience-nav--no-shadow' : ''
      }`}
    >
      <div className="experience-nav__container">
        <nav aria-label="Primary">
          <div inert={isMobileNavOpen}>
            <HamburgerButton
              isOpen={isMobileNavOpen}
              toggleMenu={toggleMenu}
              ariaControls="mobile-nav-panel"
              aria-label="Open menu"
            />
          </div>

          <MobileNav
            session={session}
            isOpen={isMobileNavOpen}
            toggleMenu={toggleMenu}
          />
        </nav>

        <div className="logo" inert={isMobileNavOpen}>
          <Logo />
        </div>

        <nav
          aria-label="Utility"
          className="button-container"
          inert={isMobileNavOpen}
        >
          {!session && <Auth0Login session={session} />}
          <SavedPlansButton session={session} />
          <CartButton />
          {isAdmin && (
            <Link
              href="/admin"
              className={`admin-header-link${
                isOnAdminPage ? ' admin-header-link--active' : ''
              }`}
              aria-current={isOnAdminPage ? 'page' : undefined}
            >
              <AdminIcon />
              Admin
            </Link>
          )}
          {session && <AvatarButton session={session} showDropdown={true} />}
        </nav>
      </div>
    </header>
  );
}
